var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"41","height":"43","viewBox":"0 0 41 43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{attrs:{"opacity":"0.9","cx":"20.5","cy":"21.5","rx":"20.5","ry":"21.5","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }